import React from 'react';
import { Search, X } from 'lucide-react';

const FilterBar = ({ filters, setFilters, categories, hideGenderFilter = false }) => {
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const clearFilters = () => {
    setFilters({
      gender: filters.gender,
      category: 'all',
      search: '',
    });
  };

  const hasFilters =
    (filters.category && filters.category !== 'all') ||
    (filters.search && filters.search.length > 0) ||
    (!hideGenderFilter && filters.gender && filters.gender !== 'all');

  return (
    <div className="border-y border-neutral-200 py-4 mb-8">
      <div className="flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
        {/* Search */}
        <div className="relative flex-1 max-w-md">
          <Search
            className="absolute left-0 top-1/2 -translate-y-1/2 text-neutral-400 w-4 h-4"
            strokeWidth={1.5}
          />
          <input
            type="text"
            placeholder="Buscar..."
            value={filters.search}
            onChange={(e) => handleFilterChange('search', e.target.value)}
            className="w-full pl-6 pr-4 py-2 text-sm bg-transparent border-b border-neutral-300 focus:outline-none focus:border-black transition-colors placeholder-neutral-400"
            data-testid="search-input"
          />
        </div>

        {/* Filters */}
        <div className="flex flex-wrap items-center gap-2">
          {!hideGenderFilter && (
            <select
              value={filters.gender}
              onChange={(e) => handleFilterChange('gender', e.target.value)}
              className="text-xs font-bold uppercase tracking-widest bg-white border border-neutral-300 hover:border-black transition-colors py-2 px-4 focus:outline-none focus:border-black"
              data-testid="gender-filter"
            >
              <option value="all">Género</option>
              <option value="MUJER">Mujer</option>
              <option value="HOMBRE">Hombre</option>
              <option value="ACCESORIOS">Accesorios</option>
            </select>
          )}

          <select
            value={filters.category}
            onChange={(e) => handleFilterChange('category', e.target.value)}
            className="text-xs font-bold uppercase tracking-widest bg-white border border-neutral-300 hover:border-black transition-colors py-2 px-4 focus:outline-none focus:border-black"
            data-testid="category-filter"
          >
            <option value="all">Categoría</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>

          {hasFilters && (
            <button
              onClick={clearFilters}
              className="text-xs font-bold uppercase tracking-widest text-neutral-500 hover:text-black transition-colors flex items-center gap-1.5 py-2 px-3"
              data-testid="clear-filters-button"
            >
              <X className="w-3.5 h-3.5" strokeWidth={2} /> Limpiar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
